import React from 'react'
import youtube from "../../images/youtube.png";
import "./style.css"
import { BlockStack, Icon, InlineStack, Text } from '@shopify/polaris';
import {
    ExternalIcon
} from '@shopify/polaris-icons';

const Video = ({ url, thumbnail, title, showCard }) => {
    return (
        <div className={`video-wrapper${showCard ? " show-video-card" : ""}`}>
            <div className="image-container">
                <div style={{ backgroundImage: `url(${thumbnail})` }} className='video-thumbnail' />
                <div className="overlay full-radius" onClick={() => window.open(url, "_blank")}>
                    <div className="play-buttonc" >
                        <img className='youtube-logo' src={youtube} alt="Youtube" />
                    </div>
                </div>
            </div>
            {
                title ? <a className='video-url' href={url} target='_blank'>
                    <InlineStack gap={200} align='start' blockAlign='center' wrap={false}>
                        <Text variant='bodyMd' as='p'>
                            {title}
                        </Text>
                        <Icon source={ExternalIcon} tone="base" />
                    </InlineStack>
                </a> : null
            }

        </div>
    )
}

export default Video